// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","exportBtns":"export-buttons_exportBtns__huTWF","excel":"export-buttons_excel__s0SA0","print":"export-buttons_print__1BaXt"};